import clsx from 'clsx';

const SUB_WIDTHS = { sm: 560, md: 680, lg: 800, full: 'none' };

/**
 * SectionTitle — canonical section header (eyebrow + heading + sub).
 * Uses homepage `.type-section-title` / `.lb-eyebrow` utilities.
 */
export function SectionTitle({
  eyebrow,
  kicker,
  title,
  subtitle,
  align = 'center',
  maxSub = 'md',
  className = '',
}) {
  const eb = eyebrow || kicker;
  const center = align === 'center';
  const subMax = SUB_WIDTHS[maxSub] ?? 680;
  const sideMargin = center ? 'auto' : 0;

  return (
    <div
      className={clsx(className)}
      style={{ textAlign: center ? 'center' : 'left', marginBottom: 'var(--section-header-gap)' }}
    >
      {eb && <span className="lb-eyebrow">{eb}</span>}

      {title && (
        <h2
          className="type-section-title"
          style={{
            maxWidth: center ? 860 : 700,
            marginLeft: sideMargin,
            marginRight: sideMargin,
          }}
        >
          {title}
        </h2>
      )}

      {subtitle && (
        <p
          className="type-body"
          style={{
            marginTop: 16,
            maxWidth: subMax === 'none' ? 'none' : subMax,
            marginLeft: sideMargin,
            marginRight: sideMargin,
          }}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}
